import { useEffect } from 'react'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { Key, useSWRConfig } from 'swr'

const mountedKeys = new Set<Key>()

const getParsedKey = (key: Key) => {
  return JSON.stringify(typeof key === 'function' ? key() : key)
}

export const useTrackedSWRKey = (key: Key) => {
  const parsedKey = getParsedKey(key)
  useEffect(() => {
    mountedKeys.add(parsedKey)
    return () => {
      mountedKeys.delete(parsedKey)
    }
  }, [parsedKey])
}

export const useRevalidateModules = () => {
  const { mutate } = useSWRConfig()

  const revalidateModules = async (modules: RequestModuleEnum[], hardRevalidate = false) => {
    const shouldHardRevalidate = (key: Key) => hardRevalidate || !mountedKeys.has(getParsedKey(key))
    await mutate(key => {
      return (
        Array.isArray(key) &&
        key.some(keyElement => modules.includes(keyElement) && shouldHardRevalidate(key))
      )
    }, undefined)

    await mutate(key => {
      return (
        Array.isArray(key) &&
        key.some(keyElement => modules.includes(keyElement) && !shouldHardRevalidate(key))
      )
    })
  }
  return {
    revalidateModules,
  }
}
